import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useExpenseInvoiceContext } from "../../context/ExpenseInvoiceContext";
import { BranchContactHeader } from "../../components/branchContact/BranchContact";
import "./expenseInvoiceDetails.css";

const ExpenseInvoiceDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { fetchExpenseInvoice, deleteExpenseInvoice } =
    useExpenseInvoiceContext();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadInvoice();
  }, [id]);

  const loadInvoice = async () => {
    try {
      const data = await fetchExpenseInvoice(id);
      setInvoice(data);
    } catch (err) {
      console.error("Error fetching invoice:", err);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDelete = async () => {
    if (window.confirm("هل أنت متأكد من حذف فاتورة الصرف؟")) {
      try {
        const response = await deleteExpenseInvoice(id);
        if (response.status === "success") {
          alert("✅ تم حذف فاتورة الصرف بنجاح");
          navigate("/expense-invoices");
        }
      } catch (err) {
        alert(err.response?.data?.message || "حدث خطأ أثناء حذف الفاتورة");
      }
    }
  };

  if (loading) {
    return (
      <div className="invoice-details-page">
        <div className="loading-container">
          <p>جارٍ تحميل تفاصيل الفاتورة...</p>
        </div>
      </div>
    );
  }

  if (!invoice) {
    return (
      <div className="invoice-details-page">
        <div className="error-container">
          <p>لم يتم العثور على الفاتورة</p>
          <Link to="/expense-invoices">العودة للفواتير</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="invoice-details-page">
      <div className="invoice-container">
        {/* Action Buttons */}
        <div className="action-buttons no-print">
          <Link to="/expense-invoices" className="back-btn">
            ← العودة للفواتير
          </Link>
          <div style={{ display: "flex", gap: "10px" }}>
            <Link to={`/expense-invoice/edit/${id}`} className="edit-btn">
              ✏️ تعديل
            </Link>
            <button className="print-btn" onClick={handlePrint}>
              🖨️ طباعة
            </button>
            <button className="delete-btn" onClick={handleDelete}>
              🗑️ حذف
            </button>
          </div>
        </div>

        <BranchContactHeader branch={invoice.branch} />

        {/* Invoice Header */}
        <div className="expense-invoice-header">
          <h1>فاتورة صرف رقم #{invoice.id}</h1>
          <div className="invoice-date">
            التاريخ: {new Date(invoice.created_at).toLocaleDateString("ar-EG")}
          </div>
        </div>

        {/* Invoice Details */}
        <div className="info-section">
          <h2>تفاصيل الفاتورة</h2>
          <div className="info-grid">
            <div className="info-item">
              <span className="label">العنوان:</span>
              <span className="value">{invoice.title}</span>
            </div>
            <div className="info-item">
              <span className="label">المبلغ:</span>
              <span className="value amount">
                {parseFloat(invoice.amount).toFixed(2)} ₪
              </span>
            </div>
          </div>

          {invoice.description && (
            <div className="description-section">
              <h3>الوصف:</h3>
              <p className="description-text">{invoice.description}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpenseInvoiceDetails;
